import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

export type RoleType = {
  roleId: number;
  roleName: string;
  roleDescription: string;
};

export type MemberType = {
  /** 구성원 이름 */
  name: string;
  /** 구성원 email */
  email: string;
  /** 구성원 position? */
  position: string | null;
  // role, MASTER 이외에 어떠한 권한있는지 확인 필요
  role: string;
  /** 구성원 권한 */
  roles: RoleType[];
  /** 휴대폰 번호 */
  phoneNumber: string;
  /** id */
  userId: string;
  /** 판매 메일 수신 여부 */
  tradeEmailRecipient: boolean;
  /** 회수 메일 수신 여부 */
  repaymentEmailRecipient: boolean;
  /** 자금일보 메일 수신 여부 */
  dailyReportRecipient: boolean;
  /** 자금일보 알림톡 수신 여부 */
  dailyReportAlimtalkRecipient: boolean;
};

export interface CompanyUserDetailResponse extends ResponseBaseWithData {
  data: MemberType;
}

interface MemberIdentifier {
  companyId: string;
  memberId: string;
}

/**
 * 인증서 등록후 계좌 스크래핑 동의 API
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.html#/company-user-controller/getCompanyUserPersonalInfo
 *
 */
export default function getCompanyUserDetail({ companyId, memberId }: MemberIdentifier) {
  return API.get<CompanyUserDetailResponse>(`/api/v2/companies/${companyId}/users/${memberId}`);
}
